export interface RevenueImpactDeal {
  id?: string
  name?: string
  color?: string
  amount?: string
  company?: {
    logo?: string
  }
}

const currencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

export function parseDealAmount(amount: string | number) {
  let num = amount

  if (typeof num === 'string') {
    num = Number.parseInt(num, 10)
  }

  if (!num) {
    num = 0
  }

  return num
}

export function formatDealAmount(amount: string | number) {
  return currencyFormat.format(parseDealAmount(amount))
}
